import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { 
    GetAll,
    Delete 
} from "adminApi/CustomersApi/Customers";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/CustomersFeilds.json";
import { FilterStatus } from "utils/FilterStatus";

const CustomerTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;
  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Customer",
  });

  const displayFields =generateDisplayFields(tabledata);

  const filterdata = FilterStatus(data);
  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data:filterdata,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: true,
    isView: true,
    config: {
      entityName: "Customer",
      editUrl: "edit-customer",
      idKey: "customer_id",
      deleteApi: Delete,
      displayFields,
      ViewUrl:"view-customer",
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default CustomerTable;
